const normalizeType = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : '');

export const resolveArtworkRoot = (artwork) => {
  if (!artwork || typeof artwork !== 'object') {
    return null;
  }
  return (
    artwork.artwork_holding
    ?? artwork.artwork
    ?? artwork.artwork_data
    ?? artwork.product_artwork
    ?? artwork.product?.artwork
    ?? artwork
  );
};

export const isAdminOnlyArtwork = (artwork) => {
  if (!artwork || typeof artwork !== 'object') {
    return false;
  }
  const root = resolveArtworkRoot(artwork) ?? artwork;
  const status =
    root?.artwork_status
    ?? root?.status
    ?? artwork?.artwork_status
    ?? artwork?.status
    ?? artwork?.metadata?.artwork_status
    ?? artwork?.product_metadata?.artwork_status
    ?? null;
  const flags =
    root?.artwork_flags
    ?? root?.flags
    ?? artwork?.artwork_flags
    ?? artwork?.flags
    ?? null;
  const label =
    root?.artwork_status_label
    ?? artwork?.artwork_status_label
    ?? null;

  return (
    status === 'sold_admin_only'
    || flags?.sold_admin_only === true
    || label === 'Sold-Admin Only'
  );
};

export const isWithdrawnArtwork = (artwork) => {
  if (!artwork || typeof artwork !== 'object') {
    return false;
  }
  const root = resolveArtworkRoot(artwork) ?? artwork;
  const status =
    root?.artwork_status
    ?? root?.status
    ?? artwork?.artwork_status
    ?? artwork?.status
    ?? artwork?.metadata?.artwork_status
    ?? artwork?.product_metadata?.artwork_status
    ?? null;
  const flags =
    root?.artwork_flags
    ?? root?.flags
    ?? artwork?.artwork_flags
    ?? artwork?.flags
    ?? null;

  return (
    status === 'unavailable'
    || flags?.withdrawn === true
    || flags?.withdrawn_at
  );
};

export const isRestrictedArtwork = (artwork) => {
  return isAdminOnlyArtwork(artwork) || isWithdrawnArtwork(artwork);
};

export const resolveHoldingType = (artwork) => {
  return (
    artwork?.metadata?.holding_type
    ?? artwork?.product_metadata?.holding_type
    ?? artwork?.holding_type
    ?? null
  );
};

export const shouldHideCollectorInteractions = (artwork, viewerType, holdingTypeOverride = null) => {
  if (!isRestrictedArtwork(artwork)) {
    return false;
  }
  const resolvedHoldingType =
    normalizeType(holdingTypeOverride)
    ?? normalizeType(resolveHoldingType(artwork));
  if (resolvedHoldingType !== 'limited_edition') {
    return false;
  }
  return true;
};
